interface Types {
  name: string;
  link: string;
  classes?: string;
  innerLink?: boolean;
}

interface Apps {
  types: Types;
  os: string;
}

interface Infos {
  apps: Apps[];
  sns: Types[];
  services: Types[];
}

interface Country {
  'ko-KR': Infos;
  'ja-JP': Infos;
  'en-US': Infos;
  'zh-TW'?: Infos;
  'fr-FR': Infos;
  'de-DE'?: Infos;
}

interface FooterInterface {
  FooterInfo: Country;
}

const EN_APPS = [
  {
    types: {
      name: 'Google play',
      link: 'https://play.google.com/store/apps/details?id=io.comico',
      classes: 'link_google'
    },
    os: 'aos'
  },
  {
    types: {
      name: 'App store',
      link: 'https://apps.apple.com/us/app/id1492654676',
      classes: 'link_appstore'
    },
    os: 'ios'
  }
];

const EN_SNS = [
  {
    name: 'Instagram',
    link: 'https://www.instagram.com/pocketcomics_official/',
    classes: 'link_instagram'
  },
  {
    name: 'Youtube',
    link: 'https://www.youtube.com/channel/UCjWW3i9YZfDzFObw_No7SrQ',
    classes: 'link_youtube'
  }
];

export const Properties: FooterInterface = {
  FooterInfo: {
    'ko-KR': {
      apps: [
        {
          types: {
            name: 'Google play',
            link:
              'https://play.google.com/store/apps/details?id=com.wisdomhouse.justoon',
            classes: 'link_google'
          },
          os: 'aos'
        },
        {
          types: {
            name: 'App store',
            link:
              'https://apps.apple.com/kr/app/%EC%BD%94%EB%AF%B8%EC%BD%94/id1504032168',
            classes: 'link_appstore'
          },
          os: 'ios'
        },
        {
          types: {
            name: 'One Store',
            link: 'http://onesto.re/0000736109',
            classes: 'link_onestore'
          },
          os: 'aos'
        }
      ],
      sns: [
        {
          name: 'Facebook',
          link: 'https://www.facebook.com/COMICO',
          classes: 'link_facebook'
        },
        {
          name: 'Twitter',
          link: 'https://twitter.com/Comico_Korea',
          classes: 'link_twit'
        },
        {
          name: 'Youtube',
          link: 'https://www.youtube.com/c/COMICO_KR',
          classes: 'link_youtube'
        },
        {
          name: 'Instagram',
          link: 'https://www.instagram.com/comico_kr/',
          classes: 'link_instagram'
        },
        {
          name: 'Naver Blog',
          link: 'https://blog.naver.com/comicokr',
          classes: 'link_blog'
        }
      ],
      services: [
        { name: '이용약관', link: '/legal/terms_of_use', innerLink: true },
        {
          name: '개인정보처리방침',
          link: '/legal/privacy_policy',
          innerLink: true
        },
        {
          name: '청소년보호정책',
          link: '/legal/youth_protection_policy',
          innerLink: true
        },
        {
          name: '사업자정보',
          link: 'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=5358102798'
        },
        {
          name: '연재문의',
          link: '/document/faq/detail?detail=%2Fdocument%2Fhelp%2F006%2F00905',
          innerLink: true
        },
        {
          name: '제휴문의',
          link: '/document/faq/detail?detail=%2Fdocument%2Fhelp%2F006%2F00908',
          innerLink: true
        }
      ]
    },
    'ja-JP': {
      apps: [
        {
          types: {
            name: 'Google play',
            link: 'https://play.google.com/store/apps/details?id=jp.comico',
            classes: 'link_google'
          },
          os: 'aos'
        },
        {
          types: {
            name: 'App store',
            link:
              'https://apps.apple.com/jp/app/comico-komiko-wu-liaode-dumerusumatokomikku/id721512660',
            classes: 'link_appstore'
          },
          os: 'ios'
        }
      ],
      sns: [
        {
          name: 'Facebook',
          link: 'https://www.facebook.com/comico.jp',
          classes: 'link_facebook'
        },
        {
          name: 'Twitter',
          link: 'https://twitter.com/comico_jp',
          classes: 'link_twit'
        }
      ],
      services: [
        // { name: 'comicoとは', link: 'https://www.comico.jp/lp/app/index.nhn' },
        { name: '利用規約', link: '/legal/terms_of_use' },
        { name: '個人情報保護', link: '/legal/privacy_policy' },
        {
          name: '資金決済法に基づく表示 ',
          link: '/legal/fund_settlement'
        },
        {
          name: '特定商取引法の表示',
          link: '/legal/special_commercial_transaction'
        },
        { name: 'ヘルプ', link: '/document/faq', innerLink: true }
      ]
    },
    'en-US': {
      apps: EN_APPS,
      sns: EN_SNS,
      services: [
        { name: 'Help', link: '/document/faq', innerLink: true },
        { name: 'Terms of use', link: '/legal/terms_of_use', innerLink: true },
        {
          name: 'Privacy policy',
          link: '/legal/privacy_policy',
          innerLink: true
        }
      ]
    },
    'zh-TW': {
      apps: EN_APPS,
      sns: [
        {
          name: 'Facebook',
          link: 'https://www.facebook.com/PocketComic',
          classes: 'link_facebook'
        },
        {
          name: 'Twitter',
          link: 'https://twitter.com/comicspocket',
          classes: 'link_twit'
        },
        {
          name: 'Youtube',
          link: 'https://www.youtube.com/channel/UCjWW3i9YZfDzFObw_No7SrQ',
          classes: 'link_youtube'
        }
      ],
      services: [
        { name: 'Help', link: '/document/faq', innerLink: true },
        { name: 'Terms of use', link: '/legal/terms_of_use', innerLink: true },
        {
          name: 'Privacy policy',
          link: '/legal/privacy_policy',
          innerLink: true
        }
      ]
    },
    'fr-FR': {
      apps: EN_APPS,
      sns: EN_SNS,
      services: [
        { name: 'Aide', link: '/document/faq', innerLink: true },
        {
          name: 'Conditions générales',
          link: '/legal/terms_of_use',
          innerLink: true
        },
        {
          name: 'Mentions légales',
          link: '/legal/privacy_policy',
          innerLink: true
        }
      ]
    },
    'de-DE': {
      apps: EN_APPS,
      sns: EN_SNS,
      services: [
        { name: 'Hilfe', link: '/document/faq', innerLink: true },
        {
          name: 'Nutzungsbedingungen',
          link: '/legal/terms_of_use',
          innerLink: true
        },
        {
          name: 'Datenschutzrichtlinie',
          link: '/legal/privacy_policy',
          innerLink: true
        }
      ]
    }
  }
};

interface PurchaseTermsInterface {
  title: string;
  message: string[];
}

export const PurchaseTerms: Array<PurchaseTermsInterface> = [
  {
    title: '',
    message: [

    ]
  },
  {
    title: '',
    message: [

    ]
  },
  {
    title: '',
    message: [
    ]
  },
  {
    title: '',
    message: [
    ]
  }
];
